import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import {
  IImportAnnotationsReport,
  importAnnotationsRejectionReasonTranslation,
} from '../../../../modules/projects/details/images/importAnnotations/models/ImportAnnotationsReport';
import { CollapsibleImportSummary } from '../../../components/CollapsibleSummary';

interface IImportAnnotationsSummaryProps extends IImportAnnotationsReport {
  isLastSummaryItem?: boolean;
}

export const ImportAnnotationsSummary = observer((props: IImportAnnotationsSummaryProps): ReactElement => {
  const { t } = useTranslator();
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const handlePanelToggle = (): void => {
    setIsPanelOpen((prevState) => !prevState);
  };

  const getRejectionReasons = (): string[] =>
    props.rejectedAnnotations.map((ra) => `${ra.datasetName} - ${ra.imageName} - ${t(importAnnotationsRejectionReasonTranslation(ra.reason))}`);

  return (
    <>
      <CollapsibleImportSummary
        importedItemsCount={props.importedAnnotationsCount}
        skippedItemsCount={props.skippedAnnotationsCount}
        rejectionReasons={getRejectionReasons()}
        isPanelOpen={isPanelOpen}
        togglePanel={handlePanelToggle}
        isLastSummaryItem={props.isLastSummaryItem}
        importedMessage={t('annotations_imported', { count: props.importedAnnotationsCount })}
        skippedMessage={t('annotations_skipped', { count: props.skippedAnnotationsCount })}
      />
    </>
  );
});
